document.addEventListener("DOMContentLoaded", notifyPopupOpen, {once:true});

function notifyPopupOpen(){
  // Handle click on links with href="#drop-form"
  document.querySelectorAll('a[href="#drop-form"]').forEach(function(link) {
    link.addEventListener('click', function(){
      document.querySelector('.store-online-or-offline').classList.add('popup-show');

      var Notification = this.getAttribute('notification');
      // console.log(Notification,'Notification');
      if (Notification) {
        document.querySelector('.store-online-or-offline input[name="User From"]').value = Notification;
      }
    
      if (this.getAttribute('current-product')) {
        var CurrentProductUrl = this.getAttribute('current-product');
        var CurrentProductTitle = this.getAttribute('product-title');

        document.querySelector('.store-online-or-offline input[name="Url"]').value = 'https://www.wearcomet.com' + CurrentProductUrl;
        document.querySelector('.store-online-or-offline input[name="Title"]').value = CurrentProductTitle;
      }
    });
  });
}

// Handle popup close button click
document.addEventListener('click', function(e) {

  if (e.target.matches('.store-online-or-offline .popup-close')) {
    var storeForm = document.querySelector('.store-online-or-offline');
    if(storeForm.classList.contains('popup-show')){
      storeForm.classList.remove('popup-show');
    }

    setTimeout(() => {
      var ShowForm = document.getElementById('notify_comet_form');
      ShowForm.style.display = "block";
      document.querySelector('.store-online-or-offline .thank-you-message').style.display = 'none';
      document.querySelector('.store-online-or-offline #form-titles').style.display = 'block';
      ShowForm.reset();
    }, 1000);
  }
});

// Handle modal overlay click
document.addEventListener('click', function(e) {
  if (e.target.matches('.store-online-or-offlines.modal-overlay')) {
    var storeForm = document.querySelector('.store-online-or-offline');
    if(storeForm.classList.contains('popup-show')){
      storeForm.classList.remove('popup-show');
    }

    setTimeout(() => {
      var ShowForm = document.getElementById('notify_comet_form');
      ShowForm.style.display = "block";
      document.querySelector('.store-online-or-offline .thank-you-message').style.display = 'none';
      document.querySelector('.store-online-or-offline #form-titles').style.display = 'block';
      ShowForm.reset();
    }, 1000);
  }
});
  
window.addEventListener("load", function() {
  // Update Variant
  document.addEventListener('product:variant:changed', function(e){
    const data = e['detail'];
    if(data && data['variant']){
      const variant_name = data['variant']['name'];
      window.wc_current_selected_variant = variant_name;
    }else{
      window.wc_current_selected_variant = null;
    }
    // console.log(window.wc_current_selected_variant);
  });
});

function notifyFormHandle() {
  const form = document.getElementById('notify_comet_form');
  if (!form) return;

  // Prevent duplicate event listeners
  if (form.dataset.listenerAttached === "true") return;
  form.dataset.listenerAttached = "true";

  const storeTypeInput = form.querySelector('input[name="Store type"]');

  form.addEventListener("submit", function (e) {
    e.preventDefault();
  
    const clickedButton = e.submitter;
    if (!clickedButton) return;
  
    const storeType = clickedButton.dataset.storeType;
    if (storeTypeInput && storeType) {
      storeTypeInput.value = storeType;
    }
  
    const loader = clickedButton.querySelector('.form-btn-loader');
    const btnText = clickedButton.querySelector('span');
  
    if (loader) loader.style.display = "block";
    if (btnText) btnText.style.display = "none";
  
    // Disable all submit buttons
    form.querySelectorAll('.store-online-or-offline .submit-button').forEach(btn => btn.disabled = true);
  
    const data = new FormData(form);
    if (window.wc_current_selected_variant) {
      data.append('Variant Name', window.wc_current_selected_variant);
    }
  
    fetch(form.action, {
      method: 'POST',
      body: data,
    })
    .then(() => {
      form.style.display = "none";
      const formTitles = document.getElementById('form-titles');
      if (formTitles) {
        formTitles.style.setProperty("display", "none");
      }
      const thankYouMessage = document.querySelector('.store-online-or-offline .thank-you-message');
      if (thankYouMessage) {
        thankYouMessage.style.setProperty("display", "block");
      }
    })
    .catch((err) => {
      console.error("Form submit error:", err);
    })
    .finally(() => {
      if (loader) loader.style.display = "none";
      if (btnText) btnText.style.display = "block";
  
      // Re-enable all submit buttons
      form.querySelectorAll('.store-online-or-offline .submit-button').forEach(btn => btn.disabled = false);
    });
  });
}

document.addEventListener("DOMContentLoaded", notifyFormHandle);